import TextInput from "components/shared/form/fields/TextInput";
import { get } from "lodash";
import RadioButton from "components/shared/form/fields/RadioButton";
import React, { useContext } from "react";
import { NewInviteContext } from "components/administration/invites/NewInvitePage";

export default function SharedInviteFields() {
  const context = useContext(NewInviteContext);

  return (
    <>
      <TextInput name="subject" label={I18n.t("js.invites.subject")} />
      <TextInput
        name="body"
        label={I18n.t("js.invites.body")}
        rows={10}
        multiline
      />
      {get(context, ["can", "invite_external_guests"]) && (
        <RadioButton
          name="user_type"
          label={I18n.t("js.invites.user_type.label")}
          hint={I18n.t("js.invites.user_type.hint")}
          options={
            get(context, ["can", "invite_external"])
              ? [
                  {
                    label: I18n.t("js.invites.user_type.normal"),
                    value: "normal",
                  },
                  {
                    label: I18n.t("js.invites.user_type.external"),
                    value: "external",
                  },
                ]
              : [
                  {
                    label: I18n.t("js.invites.user_type.external"),
                    value: "external",
                  },
                ]
          }
        />
      )}
    </>
  );
}
